import React, { useState, useEffect, ChangeEvent, FC, useContext } from "react";
import DOMPurify from "dompurify";
import { AuthContext } from "../contexts/LoginContext";
import axios from "axios";

interface EditableTextProps {
  id: string;
  isH1?: boolean;
  isH2?: boolean;
  isTL?: boolean;
}

const EditableText: FC<EditableTextProps> = ({ id, isH1 = false, isTL = false, isH2 = false }) => {
  const [text, setText] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const { isLoggedIn } = useContext(AuthContext);

  const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

  useEffect(() => {
    axios.get(`${API_BASE}/getText/${id}`)
      .then(response => {
        const fetched = response?.data?.text?.text ?? "";
        if (!fetched && isLoggedIn) {
          setText("input text here");
        } else {
          setText(fetched);
        }
      })
      .catch(() => {
        // No text in DB (404) – show placeholder when logged in
        if (isLoggedIn) {
          setText("input text here");
        } else {
          setText("");
        }
      });
  }, [id, isLoggedIn]);

  const handleDoubleClick = () => {
    if (isLoggedIn) { 
      setIsEditing(true);
    }
  };

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setText(event.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  
    const token = localStorage.getItem('token'); // Get the token from localStorage
  
    // Make a PATCH request to update the text
  axios.patch(`${API_BASE}/updateText/${id}`, { text }, {
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token || '',
      },
    })
    .then(response => console.log(response.data))
    .catch(error => console.error(error));
  };

  const sanitizedHTML = DOMPurify.sanitize(text);

  const editFrameStyle: React.CSSProperties = isLoggedIn
    ? { border: '1px dashed rgba(0, 123, 255, 0.4)', borderRadius: '4px', padding: '4px', minHeight: '1.5em' }
    : {};

  return (
    <div onDoubleClick={handleDoubleClick} style={editFrameStyle}>
      {isEditing ? (
        <textarea
          id={id}
          value={text}
          placeholder="no Text found here"
          onChange={handleChange}
          onBlur={handleBlur}
          className="form-control form-control-lg"
        />
      ) : (
        <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} className={isTL ? "fs-6" : isH1 ? "h1-responsive" : isH2 ? "h2-responsive" : "text-responsive"}/>
      )}
    </div>
  );
};

export default EditableText;